<template>
  <section
    :class="['v2-card', padded ? 'v2-card--padded' : '', flush ? 'v2-card--flush' : '', elevated ? 'v2-card--elevated' : '', clickable ? 'v2-card--clickable' : '']"
    :role="clickable ? 'button' : null"
    :tabindex="clickable ? 0 : null"
    @click="onClick"
    @keydown="onKey"
  >
    <header v-if="$slots.header || title" class="v2-card__header">
      <slot name="header">
        <h3 class="v2-headline v2-headline--display-sm">{{ title }}</h3>
        <p v-if="subtitle" class="v2-body v2-body--sm v2-body--muted">{{ subtitle }}</p>
      </slot>
      <div v-if="$slots.actions" class="v2-card__actions">
        <slot name="actions" />
      </div>
    </header>
    <div class="v2-card__body">
      <slot />
    </div>
    <footer v-if="$slots.footer" class="v2-card__footer">
      <slot name="footer" />
    </footer>
  </section>
</template>

<script>
export default {
  name: "MemberCard",
  props: {
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    padded: { type: Boolean, default: true },
    flush: { type: Boolean, default: false },
    elevated: { type: Boolean, default: false },
    clickable: { type: Boolean, default: false },
  },
  methods: {
    onClick(e) {
      if (!this.clickable) return;
      this.$emit("click", e);
    },
    onKey(e) {
      if (!this.clickable) return;
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        this.$emit("click", e);
      }
    },
  },
};
</script>

<style scoped>
.v2-card {
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xs);
  display: flex;
  flex-direction: column;
  transition: box-shadow var(--transition-fast), transform var(--transition-fast);
}

.v2-card--padded {
  padding: var(--space-5);
}

.v2-card--flush {
  padding: 0;
}

.v2-card--elevated {
  box-shadow: var(--shadow-md);
}

.v2-card--clickable {
  cursor: pointer;
}

.v2-card--clickable:hover {
  box-shadow: var(--shadow-md);
}

.v2-card--clickable:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

.v2-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-3);
  margin-bottom: var(--space-4);
}

.v2-card__body {
  flex: 1 1 auto;
  min-width: 0;
}

.v2-card__actions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-shrink: 0;
}

.v2-card__footer {
  margin-top: var(--space-4);
  padding-top: var(--space-4);
  border-top: 1px solid var(--color-border);
}
</style>
